import React, { Fragment } from 'react';
import { Modal, Spinner, Form, Button, Alert } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faFile, faFileAlt } from '@fortawesome/free-solid-svg-icons';
import { formatDateShort } from '../../utils/dateUtils';

const ReportsModal = ({
  show,
  onHide,
  user,
  reportEvents,
  loadingReports,
  selectedReportEventId,
  onEventSelect,
  onViewReport,
  onDownloadReport,
  error,
  htmlContent
}) => {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Reportes de Asistencia</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <strong>Generar reportes para: {user?.email}</strong>
        </div>
        
        {loadingReports && (
          <div className="text-center mb-3">
            <Spinner animation="border" size="sm" className="me-2" />
            Cargando eventos...
          </div>
        )}

        {reportEvents.length > 0 && (
          <Form.Group className="mb-4">
            <Form.Label>Seleccionar Evento</Form.Label>
            <Form.Select value={selectedReportEventId} onChange={onEventSelect}>
              <option value="">Selecciona un evento...</option>
              {reportEvents.map((event, index) => {
                const prevEvent = reportEvents[index - 1];
                const currentDate = new Date(event.start?.dateTime || event.start?.date);
                const prevDate = prevEvent ? new Date(prevEvent.start?.dateTime || prevEvent.start?.date) : null;
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                
                const isCurrentPast = currentDate < today;
                const isPrevPast = prevDate ? prevDate < today : null;
                const showSeparator = isPrevPast !== null && isPrevPast !== isCurrentPast;
                
                return (
                  <Fragment key={index}>
                    {showSeparator && isCurrentPast && (
                      <option disabled style={{ backgroundColor: '#f8f9fa', fontWeight: 'bold' }}>
                        ── Eventos Pasados ──
                      </option>
                    )}
                    <option value={event.id}>
                      {event.summary || 'Sin título'} - {formatDateShort(event.start?.dateTime || event.start?.date)}
                    </option>
                  </Fragment>
                );
              })}
            </Form.Select>
          </Form.Group>
        )}

        {selectedReportEventId && (
          <div>
            <h6>Visualización</h6>
            <div className="d-flex gap-2 mb-3">
              <Button 
                variant="outline-primary" 
                onClick={() => onViewReport('html')}
                disabled={loadingReports}
                style={{ minWidth: '130px', padding: '0.5rem 0.75rem' }}
              >
                <FontAwesomeIcon icon={faEye} className="me-1" />
                Ver Informe
              </Button>
            </div>

            <h6>Descargar</h6>
            <div className="d-flex gap-2 mb-3">
              <Button 
                variant="success" 
                onClick={() => onDownloadReport('xlsx')}
                disabled={loadingReports}
                style={{ 
                  minWidth: '100px', 
                  padding: '0.5rem 0.75rem',
                  backgroundColor: '#008f39',
                  borderColor: '#008f39',
                  color: 'white'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#006d2c';
                  e.target.style.borderColor = '#006d2c';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#008f39';
                  e.target.style.borderColor = '#008f39';
                }}
              >
                <FontAwesomeIcon icon={faFile} className="me-1" />
                Excel
              </Button>
              <Button 
                variant="danger" 
                onClick={() => onDownloadReport('pdf')}
                disabled={loadingReports}
                style={{ minWidth: '100px', padding: '0.5rem 0.75rem' }}
              >
                <FontAwesomeIcon icon={faFileAlt} className="me-1" />
                PDF
              </Button>
            </div>
          </div>
        )}

        {error && <Alert variant="danger" className="mt-3">{error}</Alert>}
        
        {htmlContent && (
          <div className="mt-3">
            <h6>Informe:</h6>
            <iframe 
              srcDoc={htmlContent}
              style={{ width: '100%', height: '400px', border: '1px solid #ddd', borderRadius: '4px' }}
              title="Reporte HTML"
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button 
          variant="secondary" 
          onClick={onHide}
          style={{
            backgroundColor: '#C5292B',
            borderColor: '#C5292B',
            color: 'white'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#A02225';
            e.target.style.borderColor = '#A02225';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#C5292B';
            e.target.style.borderColor = '#C5292B';
          }}
        >
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReportsModal;